module.exports = __webpack_public_path__ + "static/image/course-unrelated.svg?aa503a7f45ee71eb14dddc55a5f7aa84";